// Initialize tooltips because Bootstrap doesn't do it itself

import { Tooltip } from 'bootstrap'

new Tooltip('#tooltip-container', {
  selector: '[data-bs-toggle="tooltip"]', // This allows to use tooltips for dymanic content too
})
